import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { map } from 'rxjs/operators';
import { Pagination } from '@core/entities';
import { FilterQuery } from '@core/types';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class ClubService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  findClubMembers(pagination: Pagination, queryParams?: FilterQuery): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/memberList/${pagination.page}/${pagination.pageSize}`, { params: queryParams });
  }

  info(teamId: number, databaseId: number): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/get-club-info/${databaseId}/${teamId}`);
  }

  jubilees(teamId: number): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/check-jubilees/${teamId}`).pipe(map((response) => response.result));
  }

  birthdays(teamId: number): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/check-birthdays/${teamId}`).pipe(map((response) => response.result));
  }

  groups(teamId: number): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/teamgroups/${teamId}`);
  }

  groupsAndUsers(teamId: number) {
    return this._http.get<any>(`${this._apiUrl}/teamGroupsAndUsers/${teamId}`).pipe(
      map((response) => {
        return response.result;
      }),
    );
  }

  teamUsers(teamId: number): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/teamUsers/team/${teamId}`).pipe(
      map((response) => {
        return response;
      }),
    );
  }
}
